import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { SelectModel } from '@shared/components/select/models/select';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-multiple-select',
  templateUrl: './multiple-select.html',
  styleUrls: ['./multiple-select.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, OverlayModule, MatCheckboxModule, MatButtonModule, TranslateModule]
})
export class MultipleSelectComponent implements OnInit {
  @Input() options: SelectModel[] = [];

  @Input() set selectedOptionIndexes(optionIndexes: number[]) {
    const formArrayValues = (this.form.get('options')?.value || []).map(() => false);
    if (!formArrayValues.length) { return; }
    optionIndexes.forEach(index => { formArrayValues[index] = true; });
    this.form.get('options')?.setValue(formArrayValues);
  }

  @Output() changeSelected = new EventEmitter<({ index: number; isSelected: boolean })[]>();

  form = this.fb.group({
    options: this.fb.array([])
  });

  get optionsArray() {
    return this.form.get('options') as FormArray;
  }

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    const controls = this.options.map(() => this.fb.control(false));
    (this.form as any).setControl('options', this.fb.array(controls));
  }

  trackByFn(index: number): number {
    return index;
  }

  onSubmit() {
    const selected = this.options
      .map((option, index) => ({
        index,
        isSelected: this.optionsArray.value[index]
      }));
    this.changeSelected.emit(selected);
  }
}
